// extracted by mini-css-extract-plugin
module.exports = {"container":"rC-LTfrqz6oaTkYntDzZn","visible":"_1JpHn8Yu241-7Wq7Rtc0f5","cancelBtn":"_2YuyB-o9GjJegpmblRJTBF","icon":"_1HX0wlCjGikDTTfOILdSsK","saveBtn":"_1xR4H6VtXyg47Yq5GuHQGu"};